var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"src":require('@/assets/mezcal/cocteleria_6.jpeg')}})}
var staticRenderFns = []

export { render, staticRenderFns }